import React, { useEffect, useRef, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { GeneralInputWidthWrapper, InputError } from 'src/components';
import { TextInputExtended } from 'src/components';
import { store } from 'src/feature-app';
import { useOneFormContext } from 'src/feature-app/OneForm';
import { OneFormState } from 'src/types';

interface Props {
	name: string;
	regex: RegExp;
	required?: boolean;
	label?: string;
	disabled?: boolean;
	length?: number;
	maxLength?: number;
	minlength?: number;
	paddingTop?: string;
	errorLabel?: string;
}

export function InputRegex(props: Props) {
	const { name, regex, required, label, disabled, length, maxLength, minlength, paddingTop } = props;
	const errorLabel = props.errorLabel ? props.errorLabel : 'Formato no válido';

	const { register, errors } = useFormContext();
	const { error: contextError, setError: setContextError } = useOneFormContext();
	const { formInfo }: OneFormState = store.getState();
	const [value, setValue] = useState('');
	const [error, setError] = useState(false);
	const dispatch = useDispatch();

	const validateLenght = (value: string) => {
		if(length) {
			return value?.length == length;
		}
		else if(minlength && maxLength) {
			return value?.length >= minlength && value?.length <= maxLength;
		}
		else if(minlength){
			return value?.length >= minlength;
		}
		else if(maxLength) {
			return value?.length <= maxLength;
		}
		else {
			return true;
		}
	};

	const handleChange = (e: any) => {
		const value = e.target.value;
		setValue(value);
		setError(false);
		if (validateLenght(value)) {
			if (regex.test(value) && required) {
				dispatch({ type: 'UPDATE_FIELDS', payload: { [name]: value } });
			} else {
				setError(true);
			}
		}
	};

	return (
		<GeneralInputWidthWrapper className="regex-input-wrapper" notALayer={formInfo.notALayer} paddingTop={paddingTop}>
			<TextInputExtended
				name={name ? name : 'regex'}
				label={label ? label : ''}
				value={value}
				isFloating
				innerRef={register({
					required: {
						value: required,
						message: 'Requerido',
					},
					pattern: {
						value: regex,
						message: errorLabel,
					},
				})}
				onChange={(e) => handleChange(e)}
				required={required}
				disabled={disabled}
				maxLength={length ? length : maxLength}
			/>
			{error && <InputError className="input-error">{errorLabel}</InputError>}
		</GeneralInputWidthWrapper>
	);
}
